import { Skill } from '../../../types/Resume.types';

const isNestedSkill = (skill: Skill | string): skill is Skill => {
  return typeof (skill as Skill).label !== 'undefined';
};

export const flattenSkill = (skill: Skill | string): string =>
  isNestedSkill(skill) ? skill.label : skill;
